// GENERATED FILE - DO NOT MODIFY
import { SiteLocationModel } from "api/models/company/site-location-model";
import { SiteModel } from "api/models/company/site-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class SiteProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetSites(prefix: string | null | undefined, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<SiteModel[] | null> {
        const uri = this.buildUri(
            "/sites",
            null,
            { prefix: (prefix === null || prefix === undefined) ? undefined : prefix, filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: SiteModel[] | null = await this.get<SiteModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.SiteModel");
        return data;
    }

    public async GetSiteLocations(siteId: string | null, prefix: string | null | undefined, locationId: string | null | undefined, enabledPaging: boolean | undefined, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<SiteLocationModel[] | null> {
        const uri = this.buildUri(
            "/sites/location",
            null,
            { siteId: (siteId === null || siteId === undefined) ? undefined : siteId, prefix: (prefix === null || prefix === undefined) ? undefined : prefix, locationId: (locationId === null || locationId === undefined) ? undefined : locationId, enabledPaging: (enabledPaging === null || enabledPaging === undefined) ? undefined : enabledPaging.toString(), filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: SiteLocationModel[] | null = await this.get<SiteLocationModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.SiteLocationModel");
        return data;
    }
}
